// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import criteria from './criteria';
import formatting from './formatting';
import report from './report';
import reportIsScrollable from '../../shared/reducers/report-is-scrollable';
import showNoResultsFound from '../../shared/reducers/show-no-results-found';

export const getCombinedReducers = () =>
    combineReducers({
        busyCounter,
        criteria,
        formatting,
        report,
        reportIsScrollable,
        showNoResultsFound
    });



// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/reducers/index.js